// Admin Configuration
// Change this email to your desired admin email address
export const ADMIN_CONFIG = {
  // The email address that will have admin access
  ADMIN_EMAIL: 'abhilekhgg@gmail.com', // Main admin email

  // Alternative: You can also use a list of admin emails
  ADMIN_EMAILS: [
    'abhilekhgg@gmail.com',
    'admin@scubamail.io',
    'info@scubamail.io',
    'developer@scubamail.io'
    // Add more admin emails here if needed
  ],

  // Admin dashboard URL (keep this secret)
  // All admin URLs are under /admin/control-panel-7x9k2m
  get ADMIN_DASHBOARD_URL() {
    return '/admin/control-panel-7x9k2m/overview';
  },

  // Whether to allow multiple admins or just one
  ALLOW_MULTIPLE_ADMINS: true, // Allow multiple admins managed via invites

  // Admin signup URL for invited admins
  get ADMIN_SIGNUP_URL() {
    const isAdminMode = process.env.REACT_APP_ADMIN_MODE === 'true';
    const isAdminSubdomain = window.location.hostname.startsWith('admin.');
    return (isAdminMode || isAdminSubdomain) ? '/signup' : '/admin/signup';
  },
};

// Helper function to check if an email is admin
export const isAdminEmail = (email: string): boolean => {
  if (ADMIN_CONFIG.ALLOW_MULTIPLE_ADMINS) {
    return ADMIN_CONFIG.ADMIN_EMAILS.includes(email.toLowerCase());
  } else {
    return ADMIN_CONFIG.ADMIN_EMAIL.toLowerCase() === email.toLowerCase();
  }
};

// Helper function to get admin emails for display
export const getAdminEmails = (): string[] => {
  if (ADMIN_CONFIG.ALLOW_MULTIPLE_ADMINS) {
    return ADMIN_CONFIG.ADMIN_EMAILS;
  } else {
    return [ADMIN_CONFIG.ADMIN_EMAIL];
  }
};

